module.exports = __webpack_public_path__ + "img/features_scoremaster_phone_mobile4.d774b702.jpg";